<template>
  <div class="d-flex flex-column align-center">
    <p class="text-center">
      <span class="heading-sm-bold text-text-primary">
        {{ $t('common.components-filters.DataTableFilterNoData.filterNoData') }}
      </span>
      <br>
      <span class="text-text-secondary">{{ $t('common.components-filters.DataTableFilterNoData.filterNoDataDescription') }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'DataTableFilterNoData',
}
</script>
